import Typography from '@mui/material/Typography';
import { ConditionalWrapper } from '@qpr/components';
import { LandingPageHeadersProps } from '@qpr/landing-page/components/LandingPageHeaders';
import React from 'react';

const LandingPageHeaders = ({ headers, logo }: LandingPageHeadersProps) => {
  const Logo = logo;

  return (
    <Typography
      sx={{ height: '100px', paddingTop: '35px', top: '0px', position: 'fixed' }}
      variant="h2"
      gutterBottom
      align="inherit"
      data-testid="landingpage-title"
    >
      <ConditionalWrapper
        condition={!!headers.link}
        wrapper={() => (
          <a target="_blank" rel="noopener noreferrer" href={headers.link}>
            <Logo />
          </a>
        )}
        wrapperFalse={() => <Logo />}
      />
      {headers && headers.title}
    </Typography>
  );
};

export default LandingPageHeaders;
